import { ColumnsSettings } from '../../typings/common';

export function getDynamicLogColumnsFields(): ColumnsSettings {
    return {
        columnOrder: [
            'id',
            'date',
            'userName',
            'cid',
            'groupNo',
            'bannersNo',
            'changedFieldId',
            'changedValue',
            'expand'
        ],
        columnViewInfo: {
            id: {
                width: 80,
                hidden: false
            },
            date: {
                width: 140,
                hidden: false
            },
            userName: {
                width: 140,
                hidden: false
            },
            cid: {
                width: 180,
                hidden: false
            },
            groupNo: {
                width: 180,
                hidden: false
            },
            bannersNo: {
                width: 180,
                hidden: false
            },
            changedFieldId: {
                width: 250,
                hidden: false
            },
            changedValue: {
                width: 470,
                hidden: false
            },
            expand: {
                width: 80,
                hidden: false
            }
        }
    };
}
